export function setGlobalCSSVar(name: string, value: any) {
  document.documentElement.style.setProperty(name, value);
}
